import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { FmAvatarComponent } from '@app/shared/components/fm-avatar/fm-avatar.component'
import { CalendarDayAvailablePartner } from '../../../dashboard/components/calendar-day/calendar-day.component'
import { UserService } from '@app/core/_services/user.service'
import { take } from 'rxjs'
import { GroupInfo } from '@app/core/_models'
import {
    ContentStackItemOptions,
    ContentStackService,
} from '@app/core/_services/content-stack.service'
import { FmGroupAvatarComponent } from '@app/shared/components/fm-group-avatar/fm-group-avatar.component'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'app-profile-preview',
    imports: [FmAvatarComponent, FmGroupAvatarComponent, ButtonModule],
    templateUrl: './profile-preview.component.html',
    styleUrl: './profile-preview.component.scss',
})
export class ProfilePreviewComponent {
    @Input() data: CalendarDayAvailablePartner
    @Output() profilePreviewMouseEnter: EventEmitter<void> = new EventEmitter<void>()
    @Output() profilePreviewMouseLeave: EventEmitter<void> = new EventEmitter<void>()
    constructor(
        private userService: UserService,
        private contentStackService: ContentStackService,
    ) {}

    @HostListener('mouseenter') onMouseEnter() {
        // Prevent the tooltip from hiding when hovered
        this.profilePreviewMouseEnter.emit()
    }

    @HostListener('mouseleave') onMouseLeave() {
        // Re-enable the tooltip hiding
        this.profilePreviewMouseLeave.emit()
    }

    public sharedGroups: GroupInfo[] = []

    ngOnInit(): void {
        const groups: GroupInfo[] = []
        this.userService.currentUser.pipe(take(1)).subscribe((currentUser) => {
            for (const group of this.data.partner?.groups) {
                const sharedGroup = currentUser.group.find(
                    (element) => element.groupId === group.groupId,
                )
                if (sharedGroup) {
                    groups.push(sharedGroup)
                }
            }
            this.sharedGroups = [...groups]
        })
    }

    ngOnChanges() {}

    onClickViewProfile(): void {
        const options: ContentStackItemOptions = {
            popIfCovered: true,
            preserveStack: false,
        }
        this.contentStackService.pushProfileToDynamicPanel(this.data.partner.profileSlug, options)
    }
}
